import axios, { AxiosInstance, InternalAxiosRequestConfig, AxiosResponse } from 'axios'
import { useAuthStore } from '../stores/auth'

/**
 * Configure les intercepteurs Axios pour gérer l'authentification
 */
export function setupApiInterceptors(axiosInstance: AxiosInstance = axios) {
  // Intercepteur de requête pour ajouter le token
  axiosInstance.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
      try {
        const authStore = useAuthStore()

        // Vérifier si le token est valide et le rafraîchir si nécessaire
        if (authStore.isAuthenticated && !authStore.hasValidToken) {
          await authStore.refreshToken()
        }

        // Ajouter le token à l'en-tête Authorization si disponible
        if (authStore.token) {
          config.headers = config.headers || {}
          config.headers.Authorization = `Bearer ${authStore.token}`
        }

        return config
      } catch (error) {
        console.error('Erreur dans l\'intercepteur de requête:', error)
        return Promise.reject(error)
      }
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  // Intercepteur de réponse pour gérer les erreurs d'authentification
  axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => {
      return response
    },
    async (error) => {
      const authStore = useAuthStore()

      if (error.response?.status === 401) {
        console.warn('⚠️ Erreur 401 détectée - Token invalide ou expiré')

        // Marquer l'utilisateur comme non authentifié
        authStore.handleAuthError()

        // Tenter de récupérer un nouveau token
        try {
          await authStore.authenticate()

          // Refaire la requête originale avec le nouveau token
          const originalRequest = error.config
          if (originalRequest && !originalRequest._retry) {
            originalRequest._retry = true
            originalRequest.headers.Authorization = `Bearer ${authStore.token}`
            return axiosInstance(originalRequest)
          }
        } catch (authError) {
          console.error('❌ Impossible de récupérer un nouveau token:', authError)
          // Rediriger vers une page d'erreur ou de reconnexion si nécessaire
        }
      }

      return Promise.reject(error)
    }
  )
}

// Configuration par défaut pour l'instance Axios globale
export function initializeApiInterceptors() {
  setupApiInterceptors(axios)
  console.log('✅ Intercepteurs API configurés')
}

